import configureStore from './store';

// Configure the store beforehand.
const store = configureStore();

// Export the store by default.
export default store;
